<template>
  <div>
    <label for="stateOrProvince" class="f6 b db mb2">
      State/Province
    </label>
    <select name="stateOrProvince"
      class="ba b--black-20 pa2 mb2 db w-100 br1"
      v-model="selectedState"
    >
      <option value="">Select a State</option>
      <option v-for="(usState) in statesAndProvinces"
        :key="usState.code"
        :value="usState.code"
      >
        {{ usState.code }}
      </option>
    </select>
  </div>
</template>

<script>
import statesAndProvinces from '@/constants/registration/statesAndProvinces'

export default {
  name: 'ak-state-dropdown',
  data () {
    return {
      statesAndProvinces: statesAndProvinces,
      selectedState: ''
    }
  },
  watch: {
    selectedState (newState) {
      this.$emit('isValidUsState', newState)
    }
  }
}
</script>



// WEBPACK FOOTER //
// StateDropdown.vue?36a4ff78